import { cn } from '@/lib/utils';

export type OrbState = 'idle' | 'listening' | 'thinking' | 'talking';

interface IkalOrbProps {
  state?: OrbState;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const SPIN_DURATION: Record<OrbState, string> = {
  idle:      '6s',
  listening: '3s',
  thinking:  '2.5s',
  talking:   '1.2s',
};

const HALO_COLOR: Record<OrbState, string> = {
  idle:      'transparent',
  listening: 'rgba(193,105,79,0.55)',   // coral — "te estoy escuchando"
  thinking:  'rgba(111,187,175,0.4)',   // teal tenue
  talking:   'rgba(111,187,175,0.65)',  // teal vivo — "te estoy hablando"
};

const HALO_DURATION: Record<OrbState, string> = {
  idle:      '0s',
  listening: '0.9s',
  thinking:  '1.6s',
  talking:   '0.7s',
};

export function IkalOrb({ state = 'idle', size = 40, className, onClick }: IkalOrbProps) {
  const isActive = state !== 'idle';
  const blurPx = Math.max(2, Math.round(size * 0.22));
  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag
      {...(onClick ? { type: 'button' as const, onClick } : {})}
      className={cn(
        'relative flex items-center justify-center rounded-full focus:outline-none',
        onClick && 'transition-transform hover:scale-105 active:scale-95 cursor-pointer',
        className,
      )}
      style={{ width: size, height: size, flexShrink: 0 }}
      {...(onClick ? { title: 'Ikal – Asistente Anik' } : {})}
    >
      {/* Halo pulsante */}
      {isActive && (
        <div
          className="absolute rounded-full pointer-events-none"
          style={{
            inset: -Math.round(size * 0.08),
            border: `2px solid ${HALO_COLOR[state]}`,
            animation: `ikal-orb-pulse ${HALO_DURATION[state]} ease-in-out infinite`,
          }}
        />
      )}

      {/* Orbe aurora */}
      <div
        className="rounded-full overflow-hidden"
        style={{
          width: size,
          height: size,
          boxShadow: '0 2px 8px rgba(0,0,0,0.28)',
          animation: `ikal-aurora-spin ${SPIN_DURATION[state]} linear infinite`,
          position: 'relative',
        }}
      >
        <div style={{ position: 'absolute', inset: 0, background: '#506461' }} />
        <div
          style={{
            position: 'absolute',
            width: '70%', height: '70%',
            top: '8%', left: '6%',
            borderRadius: '50%',
            background: '#6FBBAF',
            filter: `blur(${blurPx}px)`,
            opacity: 0.9,
          }}
        />
        <div
          style={{
            position: 'absolute',
            width: '60%', height: '60%',
            top: '46%', left: '50%',
            borderRadius: '50%',
            background: '#C1694F',
            filter: `blur(${blurPx}px)`,
            opacity: 0.8,
          }}
        />
      </div>
    </Tag>
  );
}
